"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifyPairs = void 0;
var lodash_1 = require("lodash");
function stringifyPairs(keyValuePairs) {
  if (!(0, lodash_1.isArray)(keyValuePairs) || (0, lodash_1.isEmpty)(keyValuePairs)) {
    return;
  }
  return keyValuePairs.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [key, JSON.stringify(value)];
  });
}
exports.stringifyPairs = stringifyPairs;